/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';
import { ADMIN_ROLES } from '@/store/user';

const enum FilterKey {
    Doctor = 'doctorId',
    Patient = 'patientId',
    Start = 'receptionDatetime',
    Status = 'status',
}

const filter = new FilterFactory();

export default class ConsultationsFilter {
    filterHandlers = {
        update: 'consultationsFilter/updateFilter',
        reset: 'consultationsFilter/resetFilter',
        resetState: 'consultationsFilter/resetFilterState',
        removeSelected: 'consultationsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        filter.createAutocompleteEntity(FilterKey.Doctor);
        filter.setPlaceholder(FilterKey.Doctor, 'По врачу');
        filter.setName(FilterKey.Doctor, 'search_doctor');
        filter.setPreviewName(FilterKey.Doctor, 'Врач');
        filter.setClassName(FilterKey.Doctor, 'col-1-row-1');
        filter.setIconClassName(FilterKey.Doctor, 'icon-user-search');
        filter.setAction(FilterKey.Doctor, 'consultationsFilter/updateSearch');
        filter.setRoles(FilterKey.Doctor, ADMIN_ROLES)
        filter.setLoad(FilterKey.Doctor, {
            entityName: 'doctors',
            filterName: 'fullName'
        });

        // filter value is set dynamically later
        filter.createHiddenEntity(FilterKey.Patient);
        filter.setName(FilterKey.Patient, 'search_patient');
        filter.setAction(FilterKey.Patient, 'consultationsFilter/updateSearch');

        filter.createDatePickerEntity(FilterKey.Start);
        filter.setPlaceholder(FilterKey.Start, 'По дате записи');
        filter.setName(FilterKey.Start, 'search_fullMarketName');
        filter.setPreviewName(FilterKey.Start, 'Дата записи');
        filter.setClassName(FilterKey.Start, 'col-1-row-3');
        filter.setIconClassName(FilterKey.Start, 'icon-clock');
        filter.setAction(FilterKey.Start, 'consultationsFilter/updateDate');

        filter.createSelectEntity(FilterKey.Status);
        filter.setPlaceholder(FilterKey.Status, 'По статусу');
        filter.setName(FilterKey.Status, 'search_status');
        filter.setPreviewName(FilterKey.Status, 'Статус');
        filter.setClassName(FilterKey.Status, 'col-1-row-4');
        filter.setIconClassName(FilterKey.Status, 'icon-success');
        filter.setAction(FilterKey.Status, 'consultationsFilter/updateSelect');
        filter.setList(FilterKey.Status, [
            {id: 'awaiting_payment', value: 'Ожидание оплаты'},
            {id: 'payment_in_process', value: 'Оплата в обработке'},
            {id: 'pending', value: 'В обработке'},
            {id: 'confirmed', value: 'Подтверждена'},
            {id: 'canceled_by_administrator', value: 'Отмена администратором'},
            {id: 'canceled_by_patient', value: 'Отмена пациентом'},
            {id: 'patient_didnt_come', value: 'Пациент не пришёл'},
            {id: 'doctor_didnt_come', value: 'Доктор не пришёл'},
            {id: 'started', value: 'Началась'},
            {id: 'completed', value: 'Завершена'},
        ])

        this.filterModel = filter.filterModel;
    }

    public setPatientId(patientId: string) {
        console.log(patientId);
        filter.setValue(FilterKey.Patient, '89');

        console.log(filter.filterModel);
    }
}
